import { connect } from "../../../../context";
import Paginator from "./Paginator";


const mapStateToProps = ({ JobStatus }) => ({
    pagination: JobStatus.pagination,
    getJobDetails: JobStatus.actions.getJobDetails,
});

export default connect(mapStateToProps, Paginator);